'use client';

import { useSettingsModal } from '@/context/settings-modal.context';
import { UIPriority } from '@/enums/ui-priorities';
import Button, { type ButtonProps } from '@/ui/Button';
import DisabledReasonTooltip from '@/ui/DisabledReasonTooltip';
import type { ReactNode } from 'react';

type QuotaTopUpButtonProps = {
    reason: string | null;
    className?: string;
    tooltipClassName?: string;
    priorityType?: UIPriority;
    uiSize?: 'default' | 'compact';
};

export const QUOTA_TOP_UP_BUTTON_LABEL = 'Пополнить баланс';

type QuotaActionButtonProps = Omit<ButtonProps, 'onClick'> & {
    reason: string | null;
    isQuotaExhausted: boolean;
    tooltipClassName?: string;
    onClick: () => void;
    children: ReactNode;
};

export const QuotaActionButton = ({
    reason,
    isQuotaExhausted,
    tooltipClassName = 'w-full',
    onClick,
    disabled,
    children,
    ...buttonProps
}: QuotaActionButtonProps) => {
    const { openBillingTopUp } = useSettingsModal();

    return (
        <DisabledReasonTooltip reason={reason} className={tooltipClassName}>
            <Button
                {...buttonProps}
                onClick={isQuotaExhausted ? openBillingTopUp : onClick}
                disabled={isQuotaExhausted ? false : disabled}
            >
                {children}
            </Button>
        </DisabledReasonTooltip>
    );
};

export const QuotaTopUpButton = ({
    reason,
    className,
    tooltipClassName = 'w-full',
    priorityType = UIPriority.SECONDARY,
    uiSize = 'compact',
}: QuotaTopUpButtonProps) => {
    const { openBillingTopUp } = useSettingsModal();

    return (
        <DisabledReasonTooltip reason={reason} className={tooltipClassName}>
            <Button
                type="button"
                priorityType={priorityType}
                uiSize={uiSize}
                onClick={openBillingTopUp}
                className={className}
            >
                {QUOTA_TOP_UP_BUTTON_LABEL}
            </Button>
        </DisabledReasonTooltip>
    );
};
